// Batched logger for the frontend.
// Logs out to the logging endpoint every 10 messages or 3s, whichever comes first.
// There are some throttling limits imposed (see writer)
export class FrontendLogger {
    constructor(fetch, url, noop) {
        this.fetch = noop ? (...args) => null : function (...args) {
            return fetch(...args);
        };
        this.url = url;
        this.task_buffer = [];
        this.log_buffer = [];
        // call flush every 3s
        this.interval_id = setInterval(this.flush.bind(this), 3000);
        // not awaited for.
        this.writer();
    }
    // Pushes log obj into log_buffer, calls flush if it hits 10
    info(obj) {
        this.log_buffer.push(obj);
        if (this.log_buffer.length >= 10) {
            this.flush();
        }
    }
    error(obj) {
        // TODO: Type explicitly as error somehow
        this.info(obj);
    }
    end() {
        this.flush();
        this.log_buffer.push(0); // push a terminator
    }
    // Take all buffered log messages and place them on writer's in q, in batches of 10
    flush() {
        while (this.log_buffer.length != 0) {
            this.task_buffer.push(this.log_buffer.splice(0, 10));
        }
        // notify writer thread if there is data and it is waiting.
        if (this.task_buffer.length != 0) {
            if (this.waiter)
                this.waiter();
        }
    }
    // Log writing thread. Consumes msgs (chunks of logs) from task_buffer, and sends them
    // to the url endpoint.
    async writer() {
        while (true) {
            // Wait for new data if need be ('flush' notifies us by calling this.waiter())
            if (this.task_buffer.length == 0) {
                await new Promise((resolve, reject) => {
                    this.waiter = function () {
                        this.waiter = null;
                        resolve();
                    };
                });
            }
            // Consume a chunk of logs from the task buffer and keep trying forever until
            // it sends.
            //
            // There is an exponential backoff here in case of repeated failures.
            let logs = this.task_buffer.splice(0, 1)[0];
            if (logs[0] == 0) {
                clearInterval(this.interval_id);
                return;
            }
            let backoff = 2000;
            while (true) {
                try {
                    let data = await this.fetch(this.url, {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                            'x-birdi-context': 'ahwu4a'
                        },
                        body: JSON.stringify({ logs })
                    });
                    // success. sleep for 100ms to throttle clients to 10hz.
                    await new Promise(r => setTimeout(r, 100));
                    break;
                }
                catch (err) {
                    console.log("logging error:", err, "backoff", backoff);
                    // exponential backoff on error, up to max of 60s.
                    await new Promise(r => setTimeout(r, backoff));
                    backoff = Math.min(backoff * 2, 60000);
                }
            }
        }
    }
}
